var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VText',{staticClass:"form-label",class:{
  'form-label--required': _vm.required,
  'form-label--invalid': _vm.invalid,
},attrs:{"small":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }